import { LodgingOptionMassAddActionTypes, LodgingOptionMassAddState, LODGING_OPTION_MASS_ADD_DATA_FAILURE, LODGING_OPTION_MASS_ADD_DATA_REQUEST, LODGING_OPTION_MASS_ADD_DATA_SUCCESS } from "store/reducers/lodgingOption/massAdd/types";

const defaultState: LodgingOptionMassAddState = {
  isLoading: false,
  errorMessage: ""
};

export default function lodgingOptionMassAdd(state = defaultState, action: LodgingOptionMassAddActionTypes): LodgingOptionMassAddState {
  switch (action.type) {
    case LODGING_OPTION_MASS_ADD_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LODGING_OPTION_MASS_ADD_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LODGING_OPTION_MASS_ADD_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};